import { IonButton, IonText } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider';
import { ConsentService, ConsentStatus } from '../../services/consent/ConsentService';
import './ConsentBanner.css';

/**
 * Banner discreto de consentimento LGPD. Aparece no primeiro acesso,
 * fica fixo no rodapé, e some após aceitar/recusar.
 *
 * Lê a config do AnalyticsContext para decidir se deve ser exibido:
 * - Não exibe enquanto config não carregou (evita flash)
 * - Não exibe se analytics estiver desabilitado (ativo/metaAdsAtivo/analyticsAtivo = false)
 * - Não exibe se exigirConsentimento = false
 * - Bloqueio de tracking é feito pelo AnalyticsService (lê ConsentService).
 */
const ConsentBanner: React.FC = () => {
  const [status, setStatus] = useState<ConsentStatus>(ConsentService.getStatus());
  const { config } = useAnalyticsContext();

  useEffect(() => {
    const unsub = ConsentService.subscribe((s) => setStatus(s));
    return () => {
      unsub();
    };
  }, []);

  // Aguarda config carregar para não exibir prematuramente
  if (!config) return null;

  // Analytics completamente desabilitado — não há nada para consentir
  const metaAtivo = config.metaAdsAtivo === true || (config.metaAdsAtivo === undefined && config.ativo === true);
  const analyticsAtivo = config.analyticsAtivo === true || (config.analyticsAtivo === undefined && config.ativo === true);
  if (!metaAtivo && !analyticsAtivo) return null;

  // Empresa não exige consentimento explícito
  if (config.exigirConsentimento === false) return null;

  if (status !== 'unknown') return null;

  return (
    <div className="xeguei-consent-banner" role="dialog" aria-live="polite">
      <div className="xeguei-consent-banner__text">
        <IonText>
          <p style={{ margin: 0 }}>
            Utilizamos cookies e tecnologias de rastreamento para melhorar sua experiência
            e medir campanhas.{' '}
            <a
              href="https://xeguei.com.br/privacidade"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#fff', textDecoration: 'underline' }}
            >
              Saiba mais
            </a>
            .
          </p>
        </IonText>
      </div>
      <div className="xeguei-consent-banner__actions">
        <IonButton
          size="small"
          fill="outline"
          color="light"
          onClick={() => ConsentService.reject()}
        >
          Recusar
        </IonButton>
        <IonButton
          size="small"
          color="light"
          onClick={() => ConsentService.accept()}
        >
          Aceitar
        </IonButton>
      </div>
    </div>
  );
};

export default ConsentBanner;
